import { AbilityBuilder } from '@casl/ability';
import { SurfaceNodeActions } from 'services/authorization/actions';

export default function defineEditorPermissions(
  { can }: AbilityBuilder<any>,
  user: string,
): void {
  can(SurfaceNodeActions.read, 'SurfaceNode');
  // Can read surface nodes...that means opening them and reading for example text node or ris document
  can(SurfaceNodeActions.create, 'SurfaceNode');

  can(SurfaceNodeActions.update, 'SurfaceNode');

  can(SurfaceNodeActions.deleteOwned, 'SurfaceNode', { createdBy: user });

  can(SurfaceNodeActions.copy, 'SurfaceNode');

  can(SurfaceNodeActions.link, 'Surface');

  can(SurfaceNodeActions.unLink, 'SurfaceNodePointsTo', {
    'settings.createdBy': user,
  });

  can(SurfaceNodeActions.updatePosition, 'SurfaceNode');

  can(SurfaceNodeActions.addToPlaceholder, 'SurfaceProtocolNode');
  can(SurfaceNodeActions.removeFromPlaceholder, 'SurfaceProtocolNode');
}
